module.exports = __webpack_public_path__ + "mr.695c99085ff2b59f0c51.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/mr.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/mr.svg
// module chunks = styles